import RuleType = App.Data.RuleEngine.Rules.RuleType;

/**
 * Background colour per rule type.
 *
 * Kept free of component imports so display components can use it without
 * creating a cycle back through `ruleTypeRegistry`.
 */
export const RULE_TYPE_COLOR = {
	condition: "grey-lighten-5",
	rule_set: "indigo-lighten-5",
	clamp_variable: "purple-lighten-5",
	load_my_wheels_base_price: "green-lighten-5",
} satisfies Record<RuleType, string>;

export const displayColorFor = (type: RuleType): string =>
	RULE_TYPE_COLOR[type];
